export default {
  sendEvent(
    {
      action: gaAction,
      category: gaCategory,
      label: gaLabel,
      value: gaValue,
      nonInteractionEvent,
      gtmEventData
    },
    { isExternalLink }
  ) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "genericEvent",
      gaAction,
      gaCategory,
      gaLabel,
      gaValue,
      isExternalLink,
      nonInteractionEvent,
      gtmEventData
    })
  },
  sendCustomEvent(eventData) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(eventData)
  },
  sendGenericEvent(params) {
    const {
      eventName,
      eventCategory = "N/A",
      eventAction = "N/A",
      entityName = "N/A",
      entityType = "N/A",
      entitySubtype = "N/A",
      entityVariant = "N/A",
      statusType = "N/A",
      value = "N/A"
    } = params

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "genericEvent",
      event_name: eventName,
      event_category: eventCategory,
      event_action: eventAction,
      entity_name: entityName,
      entity_type: entityType,
      entity_subtype: entitySubtype,
      entity_variant: entityVariant,
      status_type: statusType,
      value
    })
  }
}
